module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Italic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Italic.eot
// module id = 7
// module chunks = 8